import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './BusinessOwner.module.css';
import femaleBusinessOwner from '../../assets/professional-banner-new.png';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
function BusinessOwner(props) {
  const { history, isAuthenticated } = props;
  const buttonOwner = !isAuthenticated ? (
    <>
      <button
        className={css.BusinessOwnerDescbtn}
        onClick={e => {
          e.stopPropagation();
          history.push(
            createResourceLocatorString('SignupAsCompanyPage', routeConfiguration(), {}, {})
          );
        }}
      >
        <FormattedMessage id="BusinessOwner.DescButton" />
      </button>
    </>
  ) : null;
  return (
    <>
      <div className={css.BusinessOwnerMain}>
        <img className={css.BusinessOwnerImg} src={femaleBusinessOwner} alt="" />
        <div className={css.BusinessOwnerWrap}>
          <div className={css.BusinessOwnerDesc}>
            <p className={css.p1}>
              <FormattedMessage id="BusinessOwner.DescFirst" />{' '}
              <span className={css.span1}>
                <FormattedMessage id="BusinessOwner.DescSpan1" />
              </span>{' '}
            </p>
            <p className={css.p2}>
              <FormattedMessage id="BusinessOwner.DescSecond" />
            </p>
            {buttonOwner}
          </div>
          <div className={css.BusinessOwnerImgSection}></div>
        </div>
      </div>
    </>
  );
}

export default compose(withRouter)(BusinessOwner);
